var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"recaptchaContainer"}),(_vm.error)?_c('div',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.error))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }